var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-164 42.3 512 512",
    style: {
      enableBackground: "new -164 42.3 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#843B90;}\n\t.st1{fill:#7ED5C5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -64.4,
    y: 127.6,
    className: "st0",
    width: 106.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -64.4,
    y: 170.3,
    className: "st0",
    width: 64,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,266.3h-192c-5.9,0-10.7,4.8-10.7,10.7v42.7c0,5.9,4.8,10.7,10.7,10.7H85c5.9,0,10.7-4.8,10.7-10.7v-42.7 C95.6,271.1,90.9,266.3,85,266.3z M74.3,308.9H-96.4v-21.3H74.3L74.3,308.9L74.3,308.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -96.4,
    y: 362.3,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32.4,
    y: 362.3,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 362.3,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -96.4,
    y: 415.6,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32.4,
    y: 415.6,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 415.6,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -96.4,
    y: 468.9,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32.4,
    y: 468.9,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 468.9,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 170.3,
    className: "st0",
    width: 21.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.3,191.6v-21.3c0-17.7-14.3-32-32-32H85V95.6h21.3c5.9,0,10.7-4.8,10.7-10.7c0-23.6-19.1-42.7-42.7-42.7 H-64.4c-23.6,0-42.7,19.1-42.7,42.7v53.3h-21.3c-17.7,0-32,14.3-32,32v158.9c0,1.1,0.1,2.1,0.2,3.2l19.3,193.1 c1.6,16.4,15.4,28.8,31.8,28.8H87c12.9,0,24.1-7.6,29.2-18.8l10.6-90.4L138.3,191.6z M74.3,63.6c7.6,0,14.7,4.1,18.5,10.7H-23.1 c-1-3.7-2.4-7.3-4.4-10.7H74.3z M-85.7,84.9c0-11.8,9.6-21.3,21.3-21.3c11.8,0,21.3,9.6,21.3,21.3c0,5.9,4.8,10.7,10.7,10.7h96 v128H-85.7V84.9z M97.6,523.3c-0.5,5.5-5.1,9.6-10.6,9.6h-196.1c-5.5,0-10.1-4.1-10.6-9.6L-139,329.2V170.3 c0-5.9,4.8-10.7,10.7-10.7h21.3v64h-10.7v21.3h21.3H74.3h21.3v-21.3H85v-64h21.3c5.9,0,10.7,4.8,10.7,10.7v160L97.6,523.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "128.9,426.3 128.8,426.3 132,394.3 132.7,394.3 135.2,372.9 134.1,372.9 137.7,351.6 137.7,351.6  138.3,346.3 138.3,330.3 138.3,330.3 138.3,212.9 138.3,191.6 126.7,445.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.6,212.9v74.7h-32c-25.8,0-47.3,18.3-52.3,42.7h-65.1v16l-0.5,4.4l65.5,0.9c1.6,7.9,4.9,15.1,9.6,21.3 h-78.9l-2.1,21.3h123.7h32v32H128.9l-2.2,18.8l-0.1,2.5h171.7c5.9,0,10.7-4.8,10.7-10.7v-42.7h32v-21.3h-85.3 c-17.7,0-32-14.3-32-32c0-17.7,14.3-32,32-32H341v-21.3h-32v-85.3h0c0-5.9-4.8-10.7-10.7-10.7h-94.7l43.2-30.8l90.9,30.3 l6.7-20.3l-96-32c-3.2-1.1-6.8-0.6-9.6,1.4l-71.9,51.3h-28.6v21.3H287.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.6,447.6l0.1-2.5l-10.6,90.4c1.4-3.1,2.3-6.5,2.7-10L126.6,447.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.6,
    y: 244.9,
    className: "st1",
    width: 64,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 244.9,
    className: "st1",
    width: 21.3,
    height: 21.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard2);
export default __webpack_public_path__ + "static/media/credit-card-2.f2405ec550422f703bd34a515d44f388.svg";
export { ForwardRef as ReactComponent };